import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, CustomInput, Form, Label, Row } from 'reactstrap';
import { useApiV2ModelContext } from '../../../contexts/ApiV2ModelContext';
export function VcsSettings({ repository }) {
    const { t } = useTranslation();
    const apiV2ModelContext = useApiV2ModelContext();
    const [vcsAnnotationsEnabled, setVcsAnnotationsEnabled] = useState(null);
    useEffect(() => {
        if (vcsAnnotationsEnabled === null) {
            setVcsAnnotationsEnabled(repository.vcsAnnotationsEnabled ?? true);
        }
    }, []);
    const handleToggleAnnotations = async (value) => {
        await apiV2ModelContext.updateAnnotations(repository.id, value);
        setVcsAnnotationsEnabled(value);
    };
    return (_jsxs("div", { "data-testid": "vcs-settings", children: [_jsx("h3", { className: "h4 flex-grow-1", children: t('settings.vcsSettings') }), _jsx(Form, { children: _jsx(Container, { children: _jsxs(Row, { className: "mt-2 mb-2", children: [_jsx(Col, { xs: 10, children: _jsxs(Label, { for: "vcsAnnotationsEnabled", className: "custom-control-left-label", children: [t('settings.annotations'), _jsx("br", {}), _jsx("small", { className: "custom-control-left-label-description", children: t('settings.annotationsDesc') })] }) }), _jsx(Col, { xs: 2, className: "text-right align-self-center", children: _jsx(CustomInput, { type: "switch", id: "vcsAnnotationsEnabled", name: "vcsAnnotationsEnabled", checked: Boolean(vcsAnnotationsEnabled), onChange: (event) => handleToggleAnnotations(event.target.checked) }) })] }) }) })] }));
}
